document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.cart-item-quantity').forEach(function(qtyContainer) {
        const minus = qtyContainer.querySelector('.minus');
        const plus = qtyContainer.querySelector('.plus');
        const input = qtyContainer.querySelector('input');

        minus.addEventListener('click', function() {
            let current = parseInt(input.value);
            if (current > 1) {
                input.value = current - 1;
            }

            form = qtyContainer.closest('form');
            form.submit();
        });

        plus.addEventListener('click', function() {
            let current = parseInt(input.value);
            input.value = current + 1;
            form = qtyContainer.closest('form');
            form.submit();
        });
    });
});

